"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValid = function (ptr, curr, requireDefined) { return requireDefined === true ?
    ptr[curr] !== undefined && ptr[curr] !== null :
    curr in ptr; };
exports.get = function (root, path, orElse, requireDefined) {
    if (path === void 0) { path = ''; }
    if (orElse === void 0) { orElse = undefined; }
    if (requireDefined === void 0) { requireDefined = true; }
    if (path === '') {
        return root;
    }
    else {
        return path.split('.').reduce(function (acc, curr, idx) {
            var ptr = idx === 0 ? root : acc;
            var isObject = ptr !== null && typeof ptr === 'object';
            var value = isObject &&
                exports.isValid(ptr, curr, requireDefined) ?
                ptr[curr] : orElse;
            return value;
        }, orElse);
    }
};
function getElse(root, path, orElse) {
    return typeof path === 'string'
        ? exports.get(Object(root), path, orElse)
        : multiPathsGetOrElse(Object(root), path, orElse);
}
exports.default = getElse;
/**
 * Of note, this actually seems redundant. Probably okay to remove.
 *
 * @param root Source object
 * @param path Expected path
 * @param orElse Return if undefined
 *
 */
function getDefinedOrElse(root, path, orElse) {
    return typeof path === 'string'
        ? exports.get(Object(root), path, orElse, true)
        : multiPathsGetOrElse(Object(root), path, orElse);
}
exports.getDefinedOrElse = getDefinedOrElse;
function multiPathsGetOrElse(root, dotPaths, orElse) {
    var found = dotPaths
        .map(function (path) { return exports.get(root, path, undefined, true); })
        .find(function (gotten) { return gotten !== undefined; });
    return found !== undefined ? found : orElse;
}
exports.multiPathsGetOrElse = multiPathsGetOrElse;
//# sourceMappingURL=getter.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/getters/getter.js
 ** module id = 152
 ** module chunks = 0
 **/